import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DocumentViewer from '../../components/Documents/DocumentViewer';
import documentService from '../../services/documentService';

const DocumentDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleDelete = async (documentId) => {
    if (window.confirm('Are you sure you want to delete this document?')) {
      try {
        await documentService.delete(documentId);
        navigate('/app/documents');
      } catch (error) {
        console.error('Error deleting document:', error);
        alert('Failed to delete document');
      }
    }
  };

  const handleEdit = () => {
    navigate(`/app/documents/${id}/edit`);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <DocumentViewer
        documentId={id}
        onDelete={handleDelete}
        onEdit={handleEdit}
      />
    </div>
  );
};

export default DocumentDetail;


